import axios from "axios";

const fetchAll = (params, config) => {
  return axios.get("/api/v1/digia_sales_invoices", { params, ...config });
};

const restart = (params) => {
  return axios.post("/api/v1/digia_sales_invoices/restart", params);
};

const exportFailed = (params) => {
  return axios.get("/api/v1/digia_sales_invoices/export_failed", {
    params,
    responseType: "blob",
  });
};

const ApiDigiaSalesInvoices = {
  fetchAll,
  restart,
  exportFailed,
};

export default ApiDigiaSalesInvoices;
